module.exports = __webpack_public_path__ + "static/media/facebook-white.55d812ba.svg";